/* istanbul ignore file */
import { shape, string, arrayOf } from 'prop-types';

export default shape({
  productId: string,
  name: string,
  price: string,
  image: shape({
    source: string,
    alt: string,
  }),
  features: arrayOf(
    shape({
      title: string,
      value: string,
    })
  ),
});
